import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../store/database';
import { TIER_ORDER, TIER_LABELS } from '../../config/house.config';
import type { SupportedLang } from '../../config/house.config';

export default function ArchivePage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const items = useStore(s => s.archive_items.filter(a => !a.deleted_at));
  const member = useStore(s => s.getMember());
  const lang = i18n.language as SupportedLang;
  const tierIdx = member ? TIER_ORDER.indexOf(member.access_tier) : -1;

  return (
    <div className="space-y-6">
      <h1 className="font-serif text-2xl tracking-widest">{t('archive.title')}</h1>
      {items.length === 0 && <p className="text-sm text-charcoal/50 font-sans">{t('archive.noItems')}</p>}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {items.map(a => {
          const tr = a.translations[lang] || a.translations.en;
          const unlocked = TIER_ORDER.indexOf(a.min_tier) <= tierIdx;
          return (
            <button key={a.id} onClick={() => navigate(unlocked ? `/archive/${a.slug}` : '/membership')}
              className="text-left border border-charcoal/5 p-5 hover:border-charcoal/15 transition-colors group">
              <p className="text-[10px] tracking-widest uppercase text-charcoal/20 font-sans mb-1">{a.house_category_slug}</p>
              <h3 className="font-serif text-lg group-hover:text-charcoal/70 transition-colors">{tr.title}</h3>
              <p className="text-sm text-charcoal/50 font-sans mt-1 line-clamp-2">{tr.content}</p>
              {!unlocked && <p className="text-[10px] text-gold font-sans mt-2">🔒 {TIER_LABELS[a.min_tier]}</p>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
